// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3o1ZJ","upload":"Small_upload__DgjzR","imageWrap":"Small_imageWrap__26DJF","removeBtn":"Small_removeBtn__3MYod"};